// TODO: Добавить тип из новой ручки в CD-203174
export function mkPromoCategoryDetails() {
  return {
    factoids: [
      {
        title: 'Срок кредита',
        value: 'до 25 лет',
      },
      {
        title: 'Первый взнос',
        value: 'От 15%',
      },
      {
        title: 'Максимальный кредит',
        value: '2,2 млн ₽',
      },
      {
        title: 'Минимальный кредит',
        value: '300 тыс. ₽',
      },
    ],
    descriptionBlock: [
      {
        title: 'Кто может воспользоваться',
        items: [
          'Офицеры, окончившие военные учебные заведения и получившие первое воинское звание после 1 января 2005 года, а также призванные на военную службу из запаса и заключившие первый контракт после 1 января 2005 года',
          'Мичманы и прапорщики, отслужившие не менее 3 лет после 1 января 2005 года',
          'Матросы, сержанты, старшины и солдаты, поступившие на службу до 1 января 2020 года, подписавшие второй контракт после 1 января 2005 года',
        ],
      },
    ],
  };
}
